import { LinesOfBusinessFetchItem } from '../types';

export const LinesOfBusiness: LinesOfBusinessFetchItem[] = [
  { id: 'AcuteCare', name: 'Acute Care' },
  { id: 'AmbulatoryCare', name: 'Ambulatory Care' },
  { id: 'LongTermCare', name: 'Long-Term Care' },
  { id: 'BehavioralHealth', name: 'Behavioral Health' },
  { id: 'RehabilitationServices', name: 'Rehabilitation Services' },
  { id: 'HomeHealthCare', name: 'Home Health Care' },
  { id: 'DiagnosticServices', name: 'Diagnostic Services' },
  { id: 'PreventiveAndWellnessServices', name: 'Preventive and Wellness Services' },
  { id: 'PharmacyServices', name: 'Pharmacy Services' },
  { id: 'TelehealthAndTelemedicine', name: 'Telehealth and Telemedicine' },
  { id: 'AncillaryServices', name: 'Ancillary Services' },
  { id: 'DentalServices', name: 'Dental Services' },
  { id: 'VisionServices', name: 'Vision Services' },
  { id: 'PublicHealthServices', name: 'Public Health Services' },
  { id: 'ResearchAndEducation', name: 'Research and Education' },
];
